const PUBLIC_PATH = process.env.VUE_APP_PUBLIC_PATH;
export const PUBLIC_SAMPLES_PATH = `${PUBLIC_PATH}assets/samples`;
export const PUBLIC_LEADS_PATH = `${PUBLIC_PATH}assets/leads`;
export const PUBLIC_PROGRESSIONS_PATH = `${PUBLIC_PATH}assets/progressions`;
export const PUBLIC_IMPULSES_PATH = `${PUBLIC_PATH}assets/impulses`;
export const STEPS_PER_QUARTER = 4;
export const LOOK_AHEAD = 0.5;
